import React from 'react';
import styled from 'styled-components';
import { triggerClientPointer } from '@services';
import { Button } from '../styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationArrow } from '@fortawesome/free-solid-svg-icons';
import { setBrowserStorageItem } from '@utils/browserStorage';
import { BROWSER_STORAGE_KEYS } from '@constants';
import { setShowPointer } from '@actions/creators';

const ShowPointer = styled(Button)`
    position: relative;
    z-index: 9;
    padding: 12px;
    border-radius: 50%;
    color: ${props => props.active ? '#fff' : '#7F9DB3'};
    background: ${props => props.active ? '#7F9DB3' : '#fff'};
    border: 1px solid #7F9DB3;
`;

export const PointerButton = ({ showPointer, dispatch }) => {
    const { pointerKey } = BROWSER_STORAGE_KEYS;

    const handleClick = async () => {
        await triggerClientPointer(!showPointer);
        dispatch(setShowPointer(!showPointer));
        setBrowserStorageItem(pointerKey, !showPointer);
    };

    return (
        <ShowPointer
            aria-label='show-pointer'
            active={showPointer}
            onClick={handleClick}>
                <FontAwesomeIcon icon={faLocationArrow} />
        </ShowPointer>
    );
};

export default PointerButton;